import { render, staticRenderFns } from "./LookDetail.vue?vue&type=template&id=0e868e31&scoped=true&"
import script from "./LookDetail.vue?vue&type=script&lang=js&"
export * from "./LookDetail.vue?vue&type=script&lang=js&"
import style0 from "./LookDetail.vue?vue&type=style&index=0&id=0e868e31&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e868e31",
  null
  
)

export default component.exports